import React, { useState, useEffect } from "react";
import { FiEdit, FiTrash2, FiPlusCircle, FiX } from "react-icons/fi";
import "../ContentManagement.css";
import { toast } from "react-toastify";
import AxiosWeb from "../../../utils/axiosWeb";

const Subsections = () => {
  const [sectionsData, setSectionsData] = useState([]);
  const [selectedSectionId, setSelectedSectionId] = useState("");
  const [subsections, setSubsections] = useState([]);

  const [showAddSubsectionModal, setShowAddSubsectionModal] =
    useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [tempSubsection, setTempSubsection] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [subsectionToDelete, setSubsectionToDelete] = useState(null);

  const [newSubsectionContent, setNewSubsectionContent] = useState({
    sectionId: "",
    title: "",
    subTitle: "",
    description: "",
    type: "Text",
    content: "",
    displayOrder: 1,
  });

  /* ---------------------------------------------------------
     Fetch All Sections
  --------------------------------------------------------- */
  const fetchAllSections = async () => {
    try {
      const response = await AxiosWeb.get(`/section/getAllSections`);

      const allSections = response.data || [];

      setSectionsData(allSections);

      if (allSections.length > 0 && !selectedSectionId) {
        setSelectedSectionId(allSections[0].id);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error.message);
    }
  };

  useEffect(() => {
    fetchAllSections();
  }, []);

  /* ---------------------------------------------------------
     Fetch Subsections
  --------------------------------------------------------- */
  const fetchSubsections = async () => {
    if (!selectedSectionId) return;

    try {
      const response = await AxiosWeb.get(
        `/subSection/getAllSubSections`
      );

      const filtered = response.data.filter(
        (s) => s.sectionId === parseInt(selectedSectionId)
      );

      setSubsections(filtered || []);
    } catch (error) {
      toast.error(error?.response?.data?.message || error.message);
    }
  };

  useEffect(() => {
    fetchSubsections();
  }, [selectedSectionId]);

  /* ---------------------------------------------------------
     File Upload Handler
  --------------------------------------------------------- */
  const handleFileChange = (e, isEditMode = false) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      const reader = new FileReader();

      reader.onload = (event) => {
        let detectedType = "File";

        if (file.type.startsWith("image/")) {
          detectedType = "Image";
        } else if (file.type.startsWith("video/")) {
          detectedType = "Video";
        } else if (file.type.startsWith("audio/")) {
          detectedType = "Audio";
        }

        const updated = {
          file,
          content: event.target.result,
          type: detectedType,
        };

        if (isEditMode) {
          setTempSubsection((prev) => ({
            ...prev,
            ...updated,
          }));
        } else {
          setNewSubsectionContent((prev) => ({
            ...prev,
            ...updated,
          }));
        }
      };

      reader.readAsDataURL(file);
    }
  };

  /* ---------------------------------------------------------
     Add Subsection Modal
  --------------------------------------------------------- */
  const handleAddSubsection = () => {
    setShowAddSubsectionModal(true);

    setNewSubsectionContent({
      sectionId: selectedSectionId,
      title: "",
      subTitle: "",
      description: "",
      type: "Text",
      content: "",
      displayOrder:
        subsections.length > 0
          ? Math.max(...subsections.map((s) => s.displayOrder)) + 1
          : 1,
    });
  };

  /* ---------------------------------------------------------
     Save New Subsection
  --------------------------------------------------------- */
  const handleSaveNewSubsection = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      formData.append(
        "title",
       (newSubsectionContent.title || "").trim()

      );

      formData.append(
        "subTitle",
        newSubsectionContent.subTitle || ""
      );

      formData.append(
        "description",
        newSubsectionContent.description || ""
      );

      formData.append(
        "type",
        newSubsectionContent.type || "Text"
      );

      formData.append(
        "displayOrder",
        newSubsectionContent.displayOrder || 1
      );

      formData.append(
        "sectionId",
        newSubsectionContent.sectionId || ""
      );

      if (newSubsectionContent.file) {
        formData.append(
          "content",
          newSubsectionContent.file
        );
      }

      await AxiosWeb.post(
        "/subSection/createSubSection",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Subsection created!");

      setShowAddSubsectionModal(false);

      fetchSubsections();
    } catch (error) {
      toast.error(
        error?.response?.data?.message || error.message
      );
    }
  };

  /* ---------------------------------------------------------
     Edit Subsection Modal
  --------------------------------------------------------- */
  const handleEditSubsection = async (sub) => {
  try {
    const response = await AxiosWeb.get(
      `/subSection/getSubSectionById?id=${sub.id}`
    );

    const data = response.data || {};

    setTempSubsection({
      ...data,

      title: (data.title || "").trim(),
      subTitle: (data.subTitle || "").trim(),
      description: data.description || "",
      content: data.content || "",

      type: data.type || "Text",
      displayOrder: data.displayOrder || 1,
      sectionId: data.sectionId || selectedSectionId,
    });

    setShowEditModal(true);
  } catch (error) {
    toast.error(
      error?.response?.data?.message || error.message
    );
  }
};
/* ---------------------------------------------------------
   Save Edited Subsection
--------------------------------------------------------- */
const handleSaveSubsection = async (e) => {
  e.preventDefault();

  try {
    const formData = new FormData();

    // Clean values
    const title = (tempSubsection?.title || "").trim();
    const subTitle = (tempSubsection?.subTitle || "").trim();
    const description = tempSubsection?.description || "";

    console.log("Original Title:", JSON.stringify(tempSubsection?.title));
    console.log("Title After Trim:", JSON.stringify(title));

    // ID
    formData.append("id", tempSubsection.id);

    // IMPORTANT:
    // Only send title when it has a value.
    // If empty, don't send "title" at all.
    if (title !== "") {
      formData.append("title", title);
    }

    // Other fields
    formData.append("subTitle", subTitle);
    formData.append("description", description);
    formData.append("type", tempSubsection.type || "Text");

    formData.append(
      "displayOrder",
      tempSubsection.displayOrder || 1
    );

    formData.append(
      "sectionId",
      tempSubsection.sectionId || selectedSectionId
    );

    // File handling
    if (tempSubsection.file) {
      formData.append("content", tempSubsection.file);
    } else {
      const contentInByte =
        tempSubsection.content?.split(",")[1] || "";

      formData.append("contentInByte", contentInByte);

      formData.append(
        "contentType",
        tempSubsection.contentType || ""
      );
    }

    // Debug - see exactly what is being sent
    console.log("----- FORM DATA -----");

    for (const [key, value] of formData.entries()) {
      console.log(
        key,
        ":",
        typeof value === "string"
          ? JSON.stringify(value)
          : value
      );
    }

    await AxiosWeb.put(
      "/subSection/updateSubSection",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success("Subsection updated!");

    setShowEditModal(false);
    setTempSubsection(null);

    fetchSubsections();

  } catch (error) {
    console.error("Update error:", error);

    toast.error(
      error?.response?.data?.message || error.message
    );
  }
};
  /* ---------------------------------------------------------
     Delete Subsection Modal
  --------------------------------------------------------- */
  const openDeleteModal = (id) => {
    setSubsectionToDelete(id);
    setShowDeleteModal(true);
  };

  const confirmDeleteSubsection = async () => {
    try {
      await AxiosWeb.delete(
        `/subSection/deleteSubSection?id=${subsectionToDelete}`
      );

      toast.success("Deleted successfully!");

      fetchSubsections();
    } catch (error) {
      toast.error(
        error?.response?.data?.message || error.message
      );
    } finally {
      setShowDeleteModal(false);
    }
  };

  /* ---------------------------------------------------------
     Preview Renderer
  --------------------------------------------------------- */
  const renderPreview = (type, content) => {
    if (!content) return null;

    if (type === "Image") {
      return (
        <img
          src={content}
          alt=""
          style={{ maxWidth: 200 }}
        />
      );
    }

    if (type === "Video") {
      return (
        <video
          controls
          style={{ maxWidth: 300 }}
        >
          <source src={content} />
        </video>
      );
    }

    if (type === "Audio") {
      return (
        <audio
          controls
          style={{ width: 250 }}
        >
          <source src={content} />
        </audio>
      );
    }

    return (
      <a
        href={content}
        target="_blank"
        rel="noreferrer"
      >
        Download File
      </a>
    );
  };

  /* ---------------------------------------------------------
     UI Rendering
  --------------------------------------------------------- */
  return (
    <div>
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <div>
          <label
            style={{
              marginRight: 10,
              fontWeight: 600,
            }}
          >
            Select Section:
          </label>

          <select
            value={selectedSectionId}
            onChange={(e) =>
              setSelectedSectionId(e.target.value)
            }
            style={{
              padding: 6,
              borderRadius: 8,
            }}
          >
            <option value="">
              -- Choose Section --
            </option>

            {sectionsData.map((s) => (
              <option
                key={s.id}
                value={s.id}
              >
                {s.title}
              </option>
            ))}
          </select>
        </div>

        {selectedSectionId && (
          <button
            onClick={handleAddSubsection}
            className="add-new-btn"
          >
            <FiPlusCircle /> Add New Subsection
          </button>
        )}
      </div>

      {/* LIST OF SUBSECTIONS */}
      {subsections.length === 0 ? (
        <p>No subsections found.</p>
      ) : (
        subsections
          .sort(
            (a, b) =>
              a.displayOrder - b.displayOrder
          )
          .map((sub) => (
            <div
              key={sub.id}
              className="content-card"
            >
              <div className="content-card-header">
                <h3>{sub.title}</h3>

                <div className="action-buttons">
                  <button
                    type="button"
                    onClick={() =>
                      handleEditSubsection(sub)
                    }
                    className="icon-btn edit-btn"
                  >
                    <FiEdit size={18} />
                  </button>

                  <button
                    type="button"
                    onClick={() =>
                      openDeleteModal(sub.id)
                    }
                    className="icon-btn delete-btn"
                  >
                    <FiTrash2 size={18} />
                  </button>
                </div>
              </div>

              <div className="content-details-expanded">
                <p>
                  <strong>Sub Title:</strong>{" "}
                  {sub.subTitle}
                </p>

                <p>
                  <strong>Description:</strong>{" "}
                  {sub.description}
                </p>

                <p>
                  <strong>Order:</strong>{" "}
                  {sub.displayOrder}
                </p>

                <p>
                  <strong>Type:</strong>{" "}
                  {sub.type}
                </p>

                {renderPreview(
                  sub.type,
                  sub.contentUrl || ""
                )}
              </div>
            </div>
          ))
      )}

      {/* -------------------------------------------------------
         ADD MODAL
      --------------------------------------------------------- */}
      {showAddSubsectionModal && (
        <div className="modal-overlay">
          <div className="modal-content">

            <div className="modal-header">
              <h3>Add New Subsection</h3>

              <button
                type="button"
                onClick={() =>
                  setShowAddSubsectionModal(false)
                }
              >
                <FiX />
              </button>
            </div>

            <form
              onSubmit={handleSaveNewSubsection}
              className="edit-form"
            >
              <label>
                Section:

                <select
                  name="sectionId"
                  value={
                    newSubsectionContent.sectionId
                  }
                  onChange={(e) =>
                    setNewSubsectionContent({
                      ...newSubsectionContent,
                      sectionId: parseInt(
                        e.target.value,
                        10
                      ),
                    })
                  }
                  required
                >
                  <option value="">
                    Select Section
                  </option>

                  {sectionsData.map((s) => (
                    <option
                      key={s.id}
                      value={s.id}
                    >
                      {s.title}
                    </option>
                  ))}
                </select>
              </label>

              <label>
                Title:

                <input
                  name="title"
                  value={
                    newSubsectionContent.title
                  }
                  onChange={(e) =>
                    setNewSubsectionContent({
                      ...newSubsectionContent,
                      title: e.target.value,
                    })
                  }
                />
              </label>

              <label>
                Sub Title:

                <input
                  name="subTitle"
                  value={
                    newSubsectionContent.subTitle
                  }
                  onChange={(e) =>
                    setNewSubsectionContent({
                      ...newSubsectionContent,
                      subTitle: e.target.value,
                    })
                  }
                />
              </label>

              <label>
                Description:

                <textarea
                  name="description"
                  value={
                    newSubsectionContent.description
                  }
                  onChange={(e) =>
                    setNewSubsectionContent({
                      ...newSubsectionContent,
                      description: e.target.value,
                    })
                  }
                />
              </label>

              <label>
                Display Order:

                <input
                  type="number"
                  name="displayOrder"
                  value={
                    newSubsectionContent.displayOrder
                  }
                  onChange={(e) =>
                    setNewSubsectionContent({
                      ...newSubsectionContent,
                      displayOrder: parseInt(
                        e.target.value,
                        10
                      ),
                    })
                  }
                />
              </label>

              <label>
                Upload File:

                <input
                  type="file"
                  onChange={handleFileChange}
                />
              </label>

              {renderPreview(
                newSubsectionContent.type,
                newSubsectionContent.content
              )}

              <div className="form-actions">
                <button
                  type="submit"
                  className="btn-save"
                >
                  Save
                </button>

                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() =>
                    setShowAddSubsectionModal(false)
                  }
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* -------------------------------------------------------
         EDIT MODAL
      --------------------------------------------------------- */}
      {showEditModal && tempSubsection && (
        <div className="modal-overlay">
          <div className="modal-content">

            <div className="modal-header">
              <h3>Edit Subsection</h3>

              <button
                type="button"
                className="modal-close-btn"
                onClick={() => {
                  setShowEditModal(false);
                  setTempSubsection(null);
                }}
              >
                <FiX />
              </button>
            </div>

            {/* IMPORTANT:
                Edit modal is now a real form
            */}
            <form
              className="edit-form"
              onSubmit={handleSaveSubsection}
            >
              <label>
                Title:

                <input
                  name="title"
                  value={
                    tempSubsection.title || ""
                  }
                  onChange={(e) =>
                    setTempSubsection({
                      ...tempSubsection,
                      title: e.target.value,
                    })
                  }
                />
              </label>

              <label>
                Sub Title:

                <input
                  name="subTitle"
                  value={
                    tempSubsection.subTitle || ""
                  }
                  onChange={(e) =>
                    setTempSubsection({
                      ...tempSubsection,
                      subTitle: e.target.value,
                    })
                  }
                />
              </label>

              <label>
                Description:

                <textarea
                  name="description"
                  value={
                    tempSubsection.description || ""
                  }
                  onChange={(e) =>
                    setTempSubsection({
                      ...tempSubsection,
                      description: e.target.value,
                    })
                  }
                />
              </label>

              <label>
                Display Order:

                <input
                  type="number"
                  name="displayOrder"
                  value={
                    tempSubsection.displayOrder || ""
                  }
                  onChange={(e) =>
                    setTempSubsection({
                      ...tempSubsection,
                      displayOrder: parseInt(
                        e.target.value,
                        10
                      ),
                    })
                  }
                />
              </label>

              <label>
                Upload File:

                <input
                  type="file"
                  onChange={(e) =>
                    handleFileChange(e, true)
                  }
                />
              </label>

              {renderPreview(
                tempSubsection.type,
                tempSubsection.content
              )}

              <div className="form-actions">
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => {
                    setShowEditModal(false);
                    setTempSubsection(null);
                  }}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn-save"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* -------------------------------------------------------
         DELETE MODAL
      --------------------------------------------------------- */}
      {showDeleteModal && (
        <div className="modal-overlay">
          <div
            className="modal-content"
            style={{
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            <h3
              style={{
                color: "#2a4e85",
                marginBottom: "15px",
                textAlign: "center",
              }}
            >
              Confirm Delete
            </h3>

            <p
              style={{
                color: "#555",
                marginBottom: "25px",
              }}
            >
              Are you sure you want to delete this
              subsection?
            </p>

            <div
              className="form-actions"
              style={{
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                className="btn-cancel"
                onClick={() =>
                  setShowDeleteModal(false)
                }
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn-save"
                style={{
                  backgroundColor: "#dc3545",
                }}
                onClick={confirmDeleteSubsection}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Subsections;